
import React from "react";
import "../../styles/PrimaryBTN.css";
import { withNamespaces } from 'react-i18next';

const PrimaryBTN = (props) => {
  return (
    <div className={props.alinhar}>
      <button className={"learn-more " + (props.novaClass || "")}>
        <a href={props.link} title={props.title}>
          <span className="circle" aria-hidden="true">
            <span className="icon arrow"></span>
          </span>
          <span className="button-text">{props.texto}</span>
        </a>
      </button>
    </div>
  );
};

export default withNamespaces() (PrimaryBTN);

